module.exports = __webpack_public_path__ + "img/Raws_logo_black_NOTagline.33d104a0.svg";